import React, { Component, Fragment } from "react";
import PropTypes from 'prop-types';
import { ModalControl } from "../../context/modal/modal-context";
import CompareModal from "./compare-modal";
import WithCompare from "./compare-container";
import Checkbox from "../../ui/components/checkbox";

const BUTTON_BAR_TOGGLE = 1024;

class CompareButton extends Component {
  //product is optional, if provided you can toggle the product in compare
  //otherwise compare button should just open the compare modal
  static defaultProps = {
    product: undefined, 
    btnText: 'Compare',
    selectedText: 'Compare',
    onCompareChange: () => {}
  }

  static propTypes = {
    /*product that will display the compare button*/
    product: PropTypes.object.isRequired,
    /*compare button's text when product is not selected*/
    btnText: PropTypes.string,
    /*compare button's text when product is selected*/
    selectedText: PropTypes.string
  }

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  checkCompare(compareProducts, product={}) {
    let { sku } = product;
    let result;
    if (compareProducts.find(prd => prd.sku == sku)) {
      result = "selected";
      if (compareProducts.length > 1) {
        result = "clickable";
      }
    } else {
      result = false;
    }
    return result;
  }

  componentDidUpdate(prevProps) {
    const { compareProducts, onCompareChange, product } = this.props;
    const { compareProducts: prevCompareProducts } = prevProps;

    // 'Clear all' on the left menu was clicked. Deselect all cards:
    if (onCompareChange) {
      if (compareProducts.length === 0 && prevCompareProducts.length > 0) {
        onCompareChange(false);
      }else{
        onCompareChange(!!this.checkCompare(compareProducts, product));
      }
    }
  }

  handleSelect() {
    const { toggleCompareProduct, compareProducts, onCompareChange, product } = this.props;
      toggleCompareProduct(product);
      if (onCompareChange) {
        onCompareChange(!!this.checkCompare(compareProducts, product));
      }
  }

  openModal = (props) => (e) => {
    e.stopPropagation();
    const { openModal } = props;
    openModal && openModal();
  }

  render() {
    const { product, compareProducts, disableCompare, btnText, selectedText, className } = this.props;
    if (disableCompare) {
      return null;
    }

    const compareState = this.checkCompare(compareProducts, product);
    const selectClass = compareState
      ? " compare-selected"
      : "";
    const clickableClass = compareState == "clickable" || !product
      ? " compare-clickable"
      : "";

    return (
      <div className={`compare${className ? ' ' + className : ''}`} aria-label="Compare" onClick={this.handleSelect}>
        {product && <button
			    tabIndex={0}
          className={`add-compare unstyled${selectClass ? ' ' + selectClass : ''}${className ? ' ' + className : ''}`}
		      aria-label="Compare"
        />}
        <ModalControl
          content={CompareModal}
          contentProps={{ ...this.props }}
          dynamicContent={true}
        >
          {props => {
            return (
              <Fragment>
                {compareState && selectedText === 'Selected to compare' && 
                  <Checkbox 
                    checked={compareState && selectedText === 'Selected to compare'}
                    size={24}
                  />
                }
                <button
                  className={"view-compare unstyled" + clickableClass}
                  onClick={clickableClass ? this.openModal(props) : null}
                  tabIndex={clickableClass ? 0 : -1}
                >
                  { compareState ? selectedText : btnText } 
                </button>
              </Fragment>
            );
          }}
        </ModalControl>
      </div>
    );
  }
}

export default WithCompare(CompareButton);